import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { CaseProvider } from "./context/CaseContext";
import { CompanySelectionProvider } from "./context/CompanySelectionContext";
import { initAppInsights } from './lib/appinsights';

const theme = createTheme({
  typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  components: {
    MuiButton: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
    MuiInputBase: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
    MuiMenuItem: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
    MuiTab: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
    MuiTableCell: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
    MuiSelect: { styleOverrides: { root: { fontFamily: '"Montserrat", sans-serif' } } },
  },
});

const queryClient = new QueryClient();
initAppInsights();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <CompanySelectionProvider>
          <CaseProvider>
            <ThemeProvider theme={theme}>
              <App />
              <ToastContainer />
            </ThemeProvider>
          </CaseProvider>
        </CompanySelectionProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </AuthProvider>
);
